import { Injectable } from '@angular/core';
import { Observable, Subscriber, Subscription } from 'rxjs';
import { ApiService } from '../base/api.service';
import { ServerResponse } from '../../interfaces/base/server.response';
import { ApiEndpointsService } from '../base/api-endpoints.service';
import { Blacklist } from '../../interfaces/configuration/blacklist';

@Injectable()

export class BlacklistService {

  constructor(private api: ApiService,
              private apiEndpoints: ApiEndpointsService,
  ) {
  }

  all(): Observable<Blacklist[] | boolean> {
    return new Observable<Blacklist[] | boolean>((o: Subscriber<Blacklist[] | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('configuration.blacklist.index')).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<Blacklist[]>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  get(id: number): Observable<Blacklist | boolean> {
    return new Observable<Blacklist | boolean>((o: Subscriber<Blacklist | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('configuration.blacklist.read', {':id': id})).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<Blacklist>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  create(formData: any): Observable<ServerResponse> {
    return this.api.post(this.apiEndpoints.get('configuration.blacklist.create'), formData);
  }

  update(id: number, formData: any): Observable<ServerResponse> {
    return this.api.put(this.apiEndpoints.get('configuration.blacklist.update', {':id': id}), formData);
  }

  delete(id: number): Observable<boolean> {
    return new Observable<boolean>((o: Subscriber<boolean>) => {
      const subscription: Subscription = this.api.delete(this.apiEndpoints.get('configuration.blacklist.delete', {':id': id})).subscribe(
        (response: ServerResponse): void => {
          if (response) {
            o.next(true);
          } else {
            o.next(false);
          }
        },
        (): void => o.next(false));

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }
}
